import { bobFossil } from './bob-fossil'
import { derekDomino } from './derek-domino'
import { ellenRipley } from './ellen-ripley'
import { sheilaMartini } from './sheila-martini'
import type { MockPersona, MockPersonaId } from './types'

export const MOCK_PERSONA_STORAGE_KEY = 'swiftaid-mock-persona'

export const MOCK_PERSONAS: Record<MockPersonaId, MockPersona> = {
  'bob-fossil': bobFossil,
  'derek-domino': derekDomino,
  'ellen-ripley': ellenRipley,
  'sheila-martini': sheilaMartini,
}

export const MOCK_PERSONA_LIST: MockPersona[] = [
  bobFossil,
  derekDomino,
  ellenRipley,
  sheilaMartini,
]

const DEFAULT_PERSONA_ID: MockPersonaId = 'bob-fossil'

function personaIdFromEnv(): MockPersonaId | null {
  const fromEnv = import.meta.env.VITE_MOCK_PERSONA as string | undefined
  if (fromEnv && fromEnv in MOCK_PERSONAS) {
    return fromEnv as MockPersonaId
  }
  return null
}

/** Active persona id: localStorage overrides VITE_MOCK_PERSONA, then Bob. */
export function getActivePersonaId(): MockPersonaId {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(MOCK_PERSONA_STORAGE_KEY)
    if (stored && stored in MOCK_PERSONAS) {
      return stored as MockPersonaId
    }
  }
  return personaIdFromEnv() ?? DEFAULT_PERSONA_ID
}

export function getActivePersona(): MockPersona {
  return MOCK_PERSONAS[getActivePersonaId()]
}

export function setActivePersonaId(id: MockPersonaId): void {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(MOCK_PERSONA_STORAGE_KEY, id)
}

export type { MockPersona, MockPersonaId } from './types'
